export default __webpack_public_path__ + "media/images/favicon-92da58524db46b76754c811facd1a7a1.svg";